import { render, staticRenderFns } from "./CourseRule.vue?vue&type=template&id=96721422&scoped=true&"
import script from "./CourseRule.ts?vue&type=script&lang=js&"
export * from "./CourseRule.ts?vue&type=script&lang=js&"
import style0 from "./CourseRule.less?vue&type=style&index=0&id=96721422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96721422",
  null
  
)

export default component.exports